module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_3.77b4ed44.png";